import Configuration from "../configs/Config";
import axios from "axios";

export const getListGmailService = email => {
  return axios.post(
    `${Configuration.urlApi}/Google/GetListGmailService?emailAddress=${email}`
  );
};
